import axios from './axios';
import { QueryClient, QueryFunction } from 'react-query';

const defaultQueryFn: QueryFunction = async ({ queryKey: [url, params] }) => {
  if (typeof url === 'string') {
    const { data } = await axios(url, { params });
    return data;
  }

  throw new Error('Invalid QueryKey');
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      staleTime: 60000,
    },
  },
});

export default queryClient;
